(function () {
  var TOUCH_KEY = 'yr_touch';
  var TOUCH_TTL_DAYS = 90;

  function captureTouch() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];
      var touch = {};
      var hasData = false;
      fields.forEach(function (key) {
        var value = params.get(key);
        if (value) {
          touch[key] = value.slice(0, 200);
          hasData = true;
        }
      });
      if (!hasData) return;
      touch.ts = Date.now();
      touch.landing = window.location.pathname;

      var stored = {};
      try { stored = JSON.parse(localStorage.getItem(TOUCH_KEY)) || {}; } catch (e) { stored = {}; }
      var ttl = TOUCH_TTL_DAYS * 24 * 60 * 60 * 1000;
      if (stored.first && Date.now() - stored.first.ts > ttl) stored = {};

      if (!stored.first) stored.first = touch;
      stored.last = touch;
      localStorage.setItem(TOUCH_KEY, JSON.stringify(stored));
    } catch (e) { /* 追踪失败不得影响页面 */ }
  }
  captureTouch();

  function setActiveGalleryImage(button) {
    if (window.matchMedia('(max-width: 920px)').matches) return;
    var target = document.querySelector(button.getAttribute('data-gallery-target'));
    if (!target) return;
    var image = button.querySelector('img');
    if (!image) return;
    var fullSrcset = button.getAttribute('data-full-srcset') || image.getAttribute('srcset');
    var fullSizes = button.getAttribute('data-sizes') || image.getAttribute('sizes');
    if (fullSrcset) {
      target.setAttribute('srcset', fullSrcset);
    } else {
      target.removeAttribute('srcset');
    }
    if (fullSizes) {
      target.setAttribute('sizes', fullSizes);
    } else {
      target.removeAttribute('sizes');
    }
    target.src = button.getAttribute('data-full-src') || image.src;
    target.alt = image.alt;
    var buttons = button.parentElement.querySelectorAll('[data-gallery-target]');
    buttons.forEach(function (item) {
      item.classList.toggle('is-active', item === button);
    });
  }

  document.addEventListener('click', function (event) {
    var galleryButton = event.target.closest('[data-gallery-target]');
    if (galleryButton) {
      setActiveGalleryImage(galleryButton);
    }

    var accordionButton = event.target.closest('[data-accordion-button]');
    if (accordionButton) {
      var item = accordionButton.closest('[data-accordion-item]');
      if (!item) return;
      item.classList.toggle('is-open');
    }

    var navToggle = event.target.closest('[data-nav-toggle]');
    if (navToggle) {
      var header = document.querySelector('.site-header');
      if (header) {
        var open = header.classList.toggle('is-nav-open');
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    var mobileNavLink = event.target.closest('.mobile-nav a');
    if (mobileNavLink) {
      var hdr = document.querySelector('.site-header');
      if (hdr) hdr.classList.remove('is-nav-open');
      var toggleBtn = document.querySelector('[data-nav-toggle]');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    }

    var waFloat = event.target.closest('[data-wa-float]');
    if (waFloat) {
      // Contact(Meta) / whatsapp_click(GA4) 通过 Shopify 客户事件广播进沙箱像素。
      // 主题主上下文够不到沙箱里的 fbq/gtag（Shopify Web Pixels 隔离），故不能直接调用——
      // 改由 Custom Pixel 订阅本事件后发送。详见 docs/tracking-plan.md。
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('yrhandlock:whatsapp_click', { page: window.location.pathname });
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'whatsapp_click', page: window.location.pathname });
      appendWaRef(waFloat);
    }
  });

  function appendWaRef(link) {
    try {
      var stored = JSON.parse(localStorage.getItem(TOUCH_KEY)) || {};
      var last = stored.last;
      if (!last || (!last.utm_campaign && !last.utm_source)) return;
      var ref = [last.utm_source, last.utm_campaign, last.utm_content].filter(Boolean).join('/');
      var url = new URL(link.href);
      var text = url.searchParams.get('text') || '';
      if (text.indexOf('[ref:') !== -1) return;
      url.searchParams.set('text', text + ' [ref: ' + ref.slice(0, 120) + ']');
      link.href = url.toString();
    } catch (e) { /* 静默 */ }
  }
})();

(function () {
  function initStickyBuyBar() {
    var atcButton = document.querySelector('#GT01ProductForm button[type="submit"]');
    var stickyBar = document.querySelector('.sticky-buy-bar');
    if (!atcButton || !stickyBar || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        document.body.classList.toggle('has-sticky-buy', !entry.isIntersecting);
      });
    });

    observer.observe(atcButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBuyBar);
  } else {
    initStickyBuyBar();
  }
})();
